import TemplateView from '../TemplateView'
import {onKeyDown, isEsc} from '../keyHandlers'
import _ from 'underscore'

export default class SearchFilter extends TemplateView {
    constructor({
        placeholder = '',
        additionalClass = '',
        onChange = (text) => {
            this.setState({text})
        },
        onClear = () => {
            this.setState({
                text: '',
            })
        },
        onBlur = () => {},
        maxLength = ''
    }) {
        super()

        this.state = {
            text: null,
        }

        this.params = {
            placeholder,
            additionalClass,
            onChange,
            onClear,
            onBlur,
            maxLength,
        }

        this.onStatePropertyChanged('text', () => {
            this.$input.attr('value', this.state.text)
            this.$close.toggle(!!this.state.text)
        })

        this._onChangeThrottled = _.debounce(this.params.onChange, 500)
        this._keyPressHandlerRemover = null
    }

    templateHtml() {
        return '<div class="searchFilterPlaceholder <%=additionalClass%>">' +
               '    <div class="inputPlaceholder">' +
               '      <input type="text" placeholder="<%=placeholder%>" maxlength="<%=maxLength%>"/>' +
               '    </div>' +
               '    <div class="close"></div>' +
               '</div>'
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
            placeholder: this.params.placeholder,
            maxLength: this.params.maxLength
        }
    }

    afterRender() {
        this.$inputPlaceholder = this.find('.searchFilterPlaceholder')
        this.$close = this.find('.close')
        this.$close.on('click', () => {
            this._handleCloseClick()
            this.focus()
        })
        this.$input = this.find('input')
                          .on('input', this._handleOnInputChange)
                          .on('focus', this._handleOnInputFocus)
                          .on('blur', this._handleOnInputBlur)
        this.renderInitialState()
    }

    _handleCloseClick = () => {
        this.params.onChange('')
        this.params.onClear()
    }

    _handleOnInputFocus = () => {
        this.$inputPlaceholder.addClass('active')
        this._keyPressHandlerRemover = onKeyDown((keyCode) => {
            if (isEsc(keyCode)) {
                this._handleCloseClick()
                return true
            }
        })
    }

    _handleOnInputBlur = () => {
        this.$inputPlaceholder.removeClass('active')
        this._keyPressHandlerRemover()
        this.params.onBlur()
    }

    _handleOnInputChange = (e) => {
        const text = e.target.value.trim()
        if (text !== this.state.text) {
            this.setStateInternal({text})
            this.$close.toggle(!!this.state.text)
            this._onChangeThrottled(text)
        }
    }

    focus() {
        this.$input.focus()
    }
}



// WEBPACK FOOTER //
// ./web/js/components/SearchFilter.js